document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper === 'undefined') {
        return;
    }

    const wraps = document.querySelectorAll('.default-slider');

    if (!wraps.length) {
        return;
    }

    const initNavigation = (swiper, wrap) => {
        const nextButtons = wrap.querySelectorAll('.slider-btn.next');
        const prevButtons = wrap.querySelectorAll('.slider-btn.prev');

        const onNext = () => swiper.slideNext();
        const onPrev = () => swiper.slidePrev();

        nextButtons.forEach((btn) => btn.addEventListener('click', onNext));
        prevButtons.forEach((btn) => btn.addEventListener('click', onPrev));

        const updateState = () => {
            const atStart = swiper.isBeginning;
            const atEnd   = swiper.isEnd;

            prevButtons.forEach((btn) => {
                btn.disabled = atStart;
                btn.classList.toggle('swiper-button-disabled', atStart);
            });
            nextButtons.forEach((btn) => {
                btn.disabled = atEnd;
                btn.classList.toggle('swiper-button-disabled', atEnd);
            });
        };

        updateState();
        swiper.on('slideChange', updateState);
        swiper.on('destroy', () => {
            nextButtons.forEach((btn) => btn.removeEventListener('click', onNext));
            prevButtons.forEach((btn) => btn.removeEventListener('click', onPrev));
        });
    };

    wraps.forEach((wrap) => {
        if (wrap.closest('.acf-block-preview')) {
            return;
        }

        const sliderEl = wrap.querySelector('.default-slider__slider');

        if (!sliderEl) {
            return;
        }

        const swiper = new Swiper(sliderEl, {
            slidesPerView : 1,
            spaceBetween  : 20,
            grabCursor    : true,
            allowTouchMove: true,
            loop          : true,
            breakpoints   : {
                625: {
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 3,
                },
                1921: {
                    slidesPerView: 4,
                },
                2560: {
                    slidesPerView: 5,
                },
            },
        });

        initNavigation(swiper, wrap);
    });
});
